import wwSettings from "@ww-digital/ww-signup-settings";
import t from "../utils/translate";
import normalizeSelectOptions from "./normalizeSelectOptions";

export const states = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "District of Columbia",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Virgin Islands",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming"
];

export const statesv2 = normalizeSelectOptions({
  options: wwSettings.getStates2()?.["en-US"],
  valueProp: "abbreviation",
  labelProp: "value"
});

export const stateText = t("STATE_SELECTBOX_LABEL");

export const statesNoTerritories = normalizeSelectOptions({
  options: wwSettings
    .getStates2()
    ?.["en-US"].filter(state => !["VI", "PR"].includes(state.abbreviation)),
  valueProp: "abbreviation",
  labelProp: "value"
});
